import React, { useEffect, useRef, useState, FC } from 'react'
import { Button, Checkbox, Col, Form, message, Modal, Row, Select, Table, Timeline, Tooltip, Upload } from 'antd'
import { YhForm, YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption, IYhForm } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, switchNum1, formatNum, momentFormat } from '@/utils/utils'
import { ITreeSelectData, useDictModel } from '@/views/base/dict/dictModel'
import { useApplyListDetailsModel } from './applyListDetailsModel'
import { ISCMApplyListDetail, ISCMApplyListFormFields } from '../../applyListTypes'
import useGlobalModel from '@/model/globalModel'
import { YhAuth } from '@/components/auth/YhAuth'
import { debounce } from 'lodash'
import { applyListService } from '../../applyListService'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import FontIcon from '@/components/YhIcon'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { PlusOutlined, PlusSquareTwoTone, UploadOutlined, UserAddOutlined, UserDeleteOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import { fileDownload } from '@/utils/exportFile'
import { UploadFile } from 'antd/lib/upload/interface'
import { YHDetailNav } from '@/components/YHDetailNav'
import { useOrgModel } from '@/views/base/organization/orgModel'
import { dictService } from '@/views/base/assetsAsk/assetsAskService'
import { ColumnsType } from 'antd/lib/table'
import { globalPrompt } from '@/components/message'
import { Image } from 'antd';
import { assetsMoveService } from '@/views/manage/assetsMove/assetsMoveService'
const changeType = {
    'assets-apply-type.transfer': 'assets.transfer',
    'assets-apply-type.discard': 'assets.cancel',
    'assets-apply-type.purchase': 'assets.storage'
}
export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const { fetchUserList } = useGlobalModel()
    const formRef = useRef<IYhFormRef>()
    const {
        editFormVal,
        addFormVal,
        saveBtnLoading,
        saveBtn,
        changeImport,
        getOneData,
        detialSelect,
        applyHistoryList,
        upFileList,
        allNameList,
        getOneNameList,
        addGoodsList,
        departmentOutValue,
        editUserData,
        addUserData,
        addUserVisible,
        formVal,
        addListVisible,
        setAddListVisible,
        setFormVal,
        setAddUserVisible,
        setAddUserData,
        setEditUserData,
        setAllNameList,
        setGetOneNameList,
        setGetOneData,
        insertSDc,
        updateSDc,
        getSDcDetailOne,
        updateEditFormVal,
        updateAddFormVal,
        resetEditCatch,
        resetAddCatch,
        setSaveBtnLoading,
        setChangeImport,
        setDetialSelect,
        setUpFileList,
        setAddGoodsList,
        verifyGoods,
        setDepartmentOutValue
    } = useApplyListDetailsModel()
    const { selectedNavId, replaceNav, findNav } = useNavModel()
    const { getSelectedDictOne } = useDictModel(() => [])
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const [departmentList, setDepartmentList] = useState<any>([])
    const CheckboxGroup = Checkbox.Group
    const { userList, user: { userName } } = useGlobalModel()
    const formListRef = useRef<IYhFormRef>();
    const [addApplyList, setAddApplyList] = useState<any>({});
    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav('5-1-1') && resetAddCatch()
            !findNav('5-1-2') && resetEditCatch()
        }
    }, [selectedNavId])

    //编辑时， 没有缓在调用详情接口 
    useEffect(() => {
        if (mode !== 'add') {
            getSDcDetailOne(id)
            return
        }
    }, [mode])
    const dataSourse = mode === 'add' ? addFormVal : editFormVal

    // useEffect(() => {
    //     if (dataSourse.typeCode && dataSourse.department) {
    //         getOne()
    //     } else {
    //         setGetOneNameList([])
    //         setGetOneData([])
    //         setAllNameList([])
    //         setDetialSelect([])
    //     }
    // }, [dataSourse.typeCode, dataSourse.department])
    const getOne = (a, b) => {
        dictService.getOne({ typeCode: a, unit: b })
            .then(({ retData }) => {
                setGetOneNameList(Object.keys(retData))
                setGetOneData(retData)
                let newList: any = []
                let nameList: any = []
                Object.keys(retData).map((item) => {
                    if (retData[item][0].status) {
                        newList.push(item)
                    }
                    retData[item].map((list) => {
                        nameList.push(list.userCode)
                    })
                })
                setAllNameList(nameList)
                setDetialSelect(newList)
            })
    }
    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        if (changedValues?.note && changedValues['note'].length > 1000) {
            message.warning('申请说明不可超过1000字符...自动截取', 5)
            saveCache({ note: changedValues.note.slice(0, 1000) })
        }
        if (changedValues?.typeCode || changedValues?.department) {
            let a = changedValues?.typeCode ?? dataSourse.typeCode
            let b = changedValues?.department ?? dataSourse.department
            if (a && b) {
                getOne(a, b)
            } else {
                setGetOneNameList([])
                setGetOneData([])
                setAllNameList([])
                setDetialSelect([])
            }
        }
        else {
            saveCache(changedValues)
        }
    }
    //机构选中
    const onCompanyChange = (value: string, node: ITreeSelectData) => {
        setDepartmentList([node])
        node && saveCache({ companyName: node.title, company: node.value, department: '', departmentName: '' })
        setDetialSelect([])
        if (addGoodsList.length > 0) {
            setAddGoodsList([])
        }
    }
    //机构选中
    const onDepartmentChange = (value: string, node: ITreeSelectData) => {
        node && saveCache({ departmentName: node.title, department: node.value })
        setChangeImport(false)
        fetchUserList(node.value)
        setDetialSelect([])
        if (addGoodsList.length > 0) {
            setAddGoodsList([])
        }
    }

    //转出部门机构选中
    const onDepartmentOutChange = (value: string, node: ITreeSelectData) => {
        node && saveCache({ departmentOutName: node.title, departmentOut: node.value, })
        if (addGoodsList.length > 0) {
            setAddGoodsList([])
        }
    }
    const changeStatus = (name: any, e) => {
        // let newList: any = []
        // getOneData[e].map((item) => {
        //     newList.push(item.id)
        // })
        // dictService.changeStatus({ idList: newList, typeCode: addFormVal.typeCode, unit: addFormVal.department ?? '', }).then((res) => {
        //     getOne()
        //     message.success('状态修改成功!')
        // })
        const newData = { ...getOneData };
        if (newData.hasOwnProperty(name)) {
            newData[name] = newData[name].map(item => ({
                ...item,
                status: e.target.checked ? 1 : 0
            }));
        }
        setGetOneData(newData)
        let newList: any = []
        let nameList: any = []
        Object.keys(newData).map((item) => {
            if (newData[item][0].status) {
                newList.push(item)
            }
            newData[item].map((list) => {
                nameList.push(list.userCode)
            })
        })
        setAllNameList(nameList)
        setDetialSelect(newList)
        message.success('状态修改成功!')
    }
    const changeTypeCode = async (value, options) => {
        saveCache({ typeCode: value, typeName: options.label, departmentOutName: '', departmentOut: '', companyName: '', company: '', department: '', departmentName: '', })
        if (addGoodsList.length > 0) {
            setAddGoodsList([])
        }
    }

    const materialTypeCodeChange = async (value, options) => {
        saveCache({ materialTypeCode: value, materialTypeName: options.label, })
        if (addGoodsList.length > 0) {
            setAddGoodsList([])
        }
    }
    //表单提交
    const onSubmit = async () => {
        const verifyResult = await verifyGoods(mode)
        if (!verifyResult) return
        formRef.current
            ?.validateFields()
            .then((val: any) => {
                const { fileList = [] } = val
                if (fileList.length > 0) {
                    let newList: any = []
                    fileList.map((item) => {
                        newList.push({ md5: item.uid, fileName: item.name })
                    })
                    val.fileList = newList
                } else {
                    val.fileList = null
                }
                delete val.createTime

                val.applyProcessList = Object.values(getOneData).flat()
                let orderNum = 0;
                let prevName = null;
                val.applyProcessList.forEach((item, index) => {
                    if (index === 0) {
                        item.orderNum = orderNum;
                        prevName = item.name;
                    } else {
                        if (item.name === prevName) {
                            item.orderNum = orderNum;
                        } else {
                            orderNum++;
                            item.orderNum = orderNum;
                            prevName = item.name;
                        }
                    }
                });
                val.typeName = val.typeCode ? getSelectedDictOne(DictCodeEnmu.ASSETS_APPLY_TYPE).find((item) => item.value == val.typeCode)?.label : ''
                if (mode === 'edit') {
                    updateSDc({
                        ...val,
                        type: changeType[val.typeCode]
                    }).then((res) => {
                        if (res) {
                            replaceNav(selectedNavId, '5-1')
                            setSaveBtnLoading(false)
                        }
                    }).catch((err) => {
                        message.warning(getFormValidatorErrText(err))
                    })
                }
                if (mode === 'add') {
                    if (val.typeCode == 'assets-apply-type.transfer') {
                        globalPrompt('modal', {
                            title: '转移申请保存提醒',
                            type: 'warning',
                            text: `当前申请单需要转移货位，请前往更新`,
                            okText: '确认转移',
                            onOk: debounce(async () => {
                                insertSDc({
                                    ...val,
                                    type: changeType[val.typeCode]
                                }).then((res) => {
                                    if (res) {
                                        replaceNav(selectedNavId, '5-1')
                                        setSaveBtnLoading(false)
                                    }
                                }).catch((err) => {
                                    message.warning(getFormValidatorErrText(err))
                                })
                            }, 500),
                            cancelText: '取消转移',
                            onCancel: () => { },
                        })
                    } else {
                        insertSDc({
                            ...val,
                            type: changeType[val.typeCode]
                        }).then((res) => {
                            if (res) {
                                replaceNav(selectedNavId, '5-1')
                                setSaveBtnLoading(false)
                            }
                        }).catch((err) => {
                            message.warning(getFormValidatorErrText(err))
                        })
                    }

                }
            })

    }

    const action = (
        <>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_AP_L_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    loading={saveBtnLoading}
                    onClick={debounce(() => {
                        const result = Object.values(getOneData)
                            .flat()
                            .some((item: any) => item.status === 1);
                        if (!result) {
                            return message.warning('请先完善勾选审批流程！')
                        } else {
                            onSubmit()
                        }
                    }, 500)}
                    disabled={mode == 'look'}
                >
                    {saveBtnLoading ? '保存中' : '保存'}
                </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_AP_L_ED_BACK}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => {
                        replaceNav(selectedNavId, '5-1')
                        setSaveBtnLoading(false)
                    }}
                >
                    返回
                </Button>
            </YhAuth>
        </>
    )

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file.response.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e.file.response.retData,
                }
                setUpFileList([...upFileList, data])
                e.fileList = [...upFileList, data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }
    const columns: ColumnsType<ISCMApplyListDetail> = [
        {
            title: '审批人',
            width: 100,
            dataIndex: 'user',
        }, {
            title: '审批时间',
            width: 120,
            dataIndex: 'processTime',
            render: (text) => `${momentFormat(text)}`
        }, {
            title: '审批结果',
            width: 100,
            dataIndex: 'supplierName',
            render: (text: string, record: any) => <span>{record.isApprove == 1 ? '已通过' : record.isApprove == 2 ? '已驳回' : '待审批'}</span>

        }, {
            title: '审批备注',
            width: 160,
            dataIndex: 'note',
        },
    ];
    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }

    const baseFormItem: any = {
        title: '基础信息',
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '申请单号',
                fieldName: 'code',
                disable: true,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '申请类型',
                fieldName: 'typeCode',
                options: getSelectedDictOne(DictCodeEnmu.ASSETS_APPLY_TYPE),
                rules: [{ required: true, message: '请选择申请类型' }],
                disable: mode !== 'add',
                onSelectChange: changeTypeCode,
            },
            ...(() => {
                if (dataSourse.typeCode == 'assets-apply-type.purchase' || dataSourse.typeCode == 'assets-apply-type.discard') {
                    return [{
                        type: FormItemTypeEnum.TreeSelect,
                        fieldLabel: '申请公司',
                        fieldName: 'company',
                        onTreeSelectChange: onCompanyChange,
                        treeData: getOrgTreeSelect(DictCodeEnmu.ORG),
                        disable: mode !== 'add',
                        rules: [{ required: true, message: '请选择申请公司' }],
                    },
                    {
                        type: FormItemTypeEnum.TreeSelect,
                        fieldLabel: '申请部门',
                        fieldName: 'department',
                        disable: mode !== 'add',
                        onTreeSelectChange: onDepartmentChange,
                        treeData: departmentList,
                        rules: [{ required: true, message: '请选择申请部门' }],
                    }]
                } else {
                    return [
                        {
                            type: FormItemTypeEnum.TreeSelect,
                            fieldLabel: '转出部门',
                            fieldName: "departmentOut",
                            onTreeSelectChange: onDepartmentOutChange,
                            treeData: getOrgTreeSelect(DictCodeEnmu.ORG),
                            rules: [{ required: true, message: '请选择转出部门' }],
                        }, {
                            type: FormItemTypeEnum.TreeSelect,
                            fieldLabel: '转入部门',
                            fieldName: 'department',
                            onTreeSelectChange: onDepartmentChange,
                            treeData: getOrgTreeSelect(DictCodeEnmu.ORG),
                            rules: [{ required: true, message: '请选择转入部门' }],
                        }, {
                            type: FormItemTypeEnum.Input,
                            fieldLabel: '转入部门意见',
                            fieldName: 'adviceIn',
                        },
                    ]
                }
            })(),
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '名称',
                fieldName: 'supplierName',
                disable: mode == 'look',
                rules: [{ required: true, message: '请输入申请名称' }],
            },
            ...(() => {
                if (dataSourse.typeCode == 'assets-apply-type.purchase') {
                    return [{
                        type: FormItemTypeEnum.Input,
                        fieldLabel: '金额',
                        fieldName: 'totalAmount',
                        disable: mode !== 'add',
                        rules: [{ required: true, pattern: /^[+-]?\d*\.?\d*$/, message: '请输入正确申请金额' }],
                    }]
                } else {
                    return []
                }
            })(),
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '申请时间',
                fieldName: 'createTime',
                disable: true,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '申请人',
                fieldName: 'createUser',
                disable: true,
                placeholder: '自动生成',
            },
            ...(() => {
                if (dataSourse.typeCode == 'assets-apply-type.discard') {
                    return [{
                        type: FormItemTypeEnum.Select,
                        fieldLabel: "物料类别",
                        fieldName: "materialTypeCode",
                        options: getSelectedDictOne(DictCodeEnmu.ASSETS_TYPE),
                        showSearch: false,
                        onSelectChange: materialTypeCodeChange,
                        rules: [{ required: true, message: "请选择物料类别" }],
                    }, {
                        type: FormItemTypeEnum.Input,
                        fieldLabel: "shopName",
                        fieldName: "materialTypeName",
                        hidden: true
                    },]
                } else {
                    return []
                }
            })(),
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'inMd5',
                colClassName: 'ant-col-h-auto',
                span: 12,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            disabled={mode !== 'add'}
                            onPreview={onPreview}
                            name="file"
                            multiple={true}
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            beforeUpload={(file) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                }
                                // return isType && isLt20M
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )
                            }}
                        >
                            <Button icon={<UploadOutlined />}>选择文件上传</Button>
                        </Upload>
                    </Form.Item>
                ),
            },
            // 带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'departmentName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'companyName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'departmentOutName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '申请类型',
                fieldName: 'typeName',
                hidden: true,
            },
        ],
    }
    const noteFormItem: IYhFormItemsBox = {
        title: '申请说明',
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: '',
                fieldName: 'note',
                labelCol: { span: 3 },
                span: 24,
            },
        ],
    }
    const flowFormItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '',
                fieldName: 'isStyle',
                span: 12,
                formItem: (<>
                    <div style={{ display: 'flex', alignItems: 'center', lineHeight: '45px', marginLeft: '15px' }}>
                        <span style={{ fontWeight: 'bolder', marginRight: '10px' }}>审批流程</span>
                        {((addFormVal.department && mode == 'add') || (!editFormVal.hasIdFive && mode == 'edit')) &&
                            <Tooltip title="添加审批">
                                <PlusSquareTwoTone
                                    style={{ fontSize: '20px', cursor: 'pointer' }}
                                    onClick={() => {
                                        formListRef.current?.resetFields();
                                        let newName = getOneNameList.length > 0 ? getOneNameList[0] + '-' + `${getOneNameList.length + 1}` : '';
                                        setAddApplyList({ name: newName })
                                        setAddListVisible(true)
                                    }}
                                />
                            </Tooltip>}
                    </div>
                    <CheckboxGroup style={{ width: '100%' }} value={detialSelect.length > 0 ? detialSelect : []} >
                        {getOneNameList.map((item: string) => {
                            return (
                                <Col span={24} style={{ marginLeft: '50px' }}>
                                    <Checkbox value={item} style={{ marginBottom: '10px' }} onClick={(e) => changeStatus(item, e)}>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{item}</span>
                                    </Checkbox>
                                    <Timeline >
                                        {getOneData[item] && getOneData[item].map((list: any) => {
                                            return (
                                                <Timeline.Item color="green" style={{ marginLeft: '50px' }} >
                                                    <Row style={{ width: '700px' }}>
                                                        <Col style={{ width: '250px' }}>
                                                            <Tooltip placement="topLeft" title={list.departmentName}>
                                                                <span style={{ marginRight: '50px', fontSize: '18px' }} >{list.departmentNam?.length > 10 ? list.departmentName.slice(0, 10) + '...' : list.departmentName}</span>
                                                            </Tooltip>
                                                        </Col>
                                                        <Col style={{ width: '140px' }}>
                                                            <span style={{ marginRight: '50px', fontSize: '18px', color: '#4949db', cursor: 'pointer' }}
                                                                onClick={() => { setAddUserVisible(true); setEditUserData(list) }}
                                                            >{list.user}</span>
                                                        </Col>
                                                        <Col style={{ width: '250px' }}>
                                                            {/* <UserAddOutlined style={{ marginRight: '10px', color: 'green' }}
                                                                onClick={() => { setAddUserVisible(true); setAddUserData(list) }}
                                                            /> */}
                                                            <UserDeleteOutlined style={{ color: 'red' }}
                                                                onClick={() => deleteUser(list)}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Timeline.Item>
                                            )
                                        })}
                                    </Timeline>
                                </Col>
                            )
                        })}
                    </CheckboxGroup>
                </>
                ),
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '',
                fieldName: 'isStyle',
                span: 12,
                hidden: mode !== 'look',
                formItem: (<>
                    <span style={{ fontWeight: 'bolder', lineHeight: '45px' }}>审批记录</span>
                    <Table rowKey={(record) => record.id} columns={columns} dataSource={applyHistoryList} bordered />
                </>
                ),
            },
        ],
    }
    const deleteUser = (list) => {
        // dictService.delectUser(list.id).then((res) => {
        //     getOne()
        //     message.success('审批人删除成功!')
        //     setAddUserData({})
        // })
        const newData = { ...getOneData };
        if (newData.hasOwnProperty(list.name)) {
            newData[list.name] = newData[list.name].filter(item => item.user !== list.user);
            if (newData[list.name].length === 0) {
                delete newData[list.name];
            }
        }
        setGetOneData(newData)
        setGetOneNameList(Object.keys(newData))
        let newList: any = []
        let nameList: any = []
        Object.keys(newData).map((item) => {
            if (newData[item][0].status) {
                newList.push(item)
            }
            newData[item].map((list) => {
                nameList.push(list.userCode)
            })
        })
        setAllNameList(nameList)
        setDetialSelect(newList)
        message.success('审批人删除成功!')
        setAddUserData({})
    }
    const poFromConfig: IYhFormBox<ISCMApplyListFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'add' ? addFormVal : editFormVal,
        onChange,
        boxs: dataSourse.typeCode == 'assets-apply-type.purchase' ? [baseFormItem, noteFormItem, flowFormItem] : [baseFormItem, flowFormItem],
        disabled: mode == 'look',
    }
    const chengeCompany = async (value, options) => {
        setFormVal({
            ...formVal,
            departmentName: options.orgName,
            department: options.orgCode,
            user: options.label,
            userCode: options.code,
        })
    }
    const chengeUserList = async (value, options) => {
        setAddApplyList({
            departmentName: options.orgName,
            department: options.orgCode,
            user: options.label,
            userCode: options.code,
        })
    }
    const changeUser = async (value) => {
        if (allNameList.includes(formVal?.userCode)) {
            globalPrompt("message", { text: "不可选择重复联系人！", type: "warning" });
            return;
        }
        let data = {
            name: editUserData.name ?? addUserData.name,
            typeCode: editUserData.typeCode ?? dataSourse.typeCode,
            typeName: editUserData.typeName ?? dataSourse.typeName,
            user: formVal?.user,
            userCode: formVal?.userCode,
            department: formVal?.department,
            departmentName: formVal?.departmentName,
            status: 1,
            unit: dataSourse?.department,
            unitName: dataSourse?.departmentName,
            deleteFlag: 0
        }

        if (!data.user || !data.name) {
            globalPrompt("message", { text: "请检查必填项", type: "warning" });
            return;
        }
        const newData = { ...getOneData };
        if (getOneNameList.includes(editUserData.name)) {
            if (newData.hasOwnProperty(editUserData.name)) {
                for (let i = 0; i < newData[editUserData.name].length; i++) {
                    if (newData[editUserData.name][i].user === editUserData.user) {
                        newData[editUserData.name][i] = data;
                    }
                }
                globalPrompt("message", { type: "success", text: "审批人修改成功！" });
            }
        } else {
            if (newData.hasOwnProperty(addUserData.name)) {
                newData[addUserData.name] = [...newData[addUserData.name], data];
                globalPrompt("message", { type: "success", text: "审批人添加成功！" });
            }
        }
        setGetOneData(newData)
        let newList: any = []
        let nameList: any = []
        Object.keys(newData).map((item) => {
            if (newData[item][0].status) {
                newList.push(item)
            }
            newData[item].map((list) => {
                nameList.push(list.userCode)
            })
        })
        setAllNameList(nameList)
        setDetialSelect(newList)
        // getOne()
        setAddUserData({})
        setEditUserData({})
        setAddUserVisible(false)


    }
    const handleCancel = () => {
        console.log('Clicked cancel button');
        setAddApplyList({})
        setAddListVisible(false);
    };

    const getName = async () => {
        if (formVal.name && getOneNameList.includes(formVal.name)) {
            globalPrompt("message", { text: "审批名称不可重复！", type: "warning" });
            setFormVal({ ...formVal, name: '' });
        }
    }
    const formConfig: any = {
        formRef: formListRef,
        labelCol: { span: 6 },
        formValues: {
            ...addApplyList,
            typeCode: dataSourse.typeCode,
            typeName: dataSourse.typeName,
        },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '申请类型',
                fieldName: 'typeName',
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '审批名称',
                fieldName: 'name',
                span: 24,
                onInputBlur: getName,
                rules: [{ required: true, message: '该项为必填项' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '所属部门',
                fieldName: 'departmentName',
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '审批人',
                fieldName: 'user',
                options: userList,
                showSearch: true,
                onSelectChange: chengeUserList,
                span: 24,
                rules: [{ required: true, message: '该项为必填项' }],
            },
        ],
    };
    function getNextOrderNum(data) {
        console.log(data);
        debugger
        const allArrays = Object.values(data);
        const allObjects: any = allArrays.reduce((acc: any, curr: any) => acc.concat(curr), []);
        let lastOrderNum = 0
        lastOrderNum = allObjects.length;
        return lastOrderNum;
    }
    const onOk = () => {
        formListRef.current
            ?.validateFields()
            .then(async (val: any) => {
                let data = {
                    ...addApplyList,
                    typeCode: dataSourse.typeCode,
                    typeName: dataSourse.typeName,
                    name: val.name,
                    status: 1,
                    unit: dataSourse.department,
                    unitName: dataSourse.departmentName,
                    createUser: userName,
                    deleteFlag: 0
                }
                // let { retData } = await dictService.insert(data);
                // retData &&
                let newData = {
                    ...getOneData,
                    [val.name]: [data]
                }
                setGetOneData(newData)
                setGetOneNameList([...getOneNameList, val.name])
                let newList: any = []
                let nameList: any = []
                Object.keys(newData).map((item) => {
                    if (newData[item][0].status) {
                        newList.push(item)
                    }
                    newData[item].map((list) => {
                        nameList.push(list.userCode)
                    })
                })
                setAllNameList(nameList)
                setDetialSelect(newList)
                // getOne()
                setAddApplyList({})
                setAddListVisible(false)
                globalPrompt("message", { type: "success", text: "审批流程添加成功！" });
            })
    }
    return (
        <>
            <YHDetailNav title={`${mode === 'edit' ? '编辑' : mode === 'look' ? '查看' : '新增'}`} btns={action} style={{ marginBottom: '8px' }} />
            <YhFormBox {...poFromConfig} />
            <Modal
                title="编辑审批人"
                visible={addUserVisible}
                width={600}
                onOk={() => changeUser('addUser')}
                onCancel={() => {
                    setAddUserVisible(false)
                }}
            >
                <span>请选择审批人：</span>
                <Select
                    showSearch={true}
                    options={userList.map((item) => { return { ...item, value: item.label } })}
                    onChange={chengeCompany}
                />
            </Modal>
            <Modal
                title="添加审批"
                visible={addListVisible}
                onOk={onOk}
                onCancel={handleCancel}
            >
                <YhForm  {...formConfig} />
            </Modal>
        </>
    )
}
